export function features() {

    function handleMediaQuery(event) {
        if (event.matches) {
            tabAnim()
        } else {
            tabAnimMob()
        }
    }

    const mediaQuery = window.matchMedia('(min-width: 750px)');
    mediaQuery.addEventListener('change', handleMediaQuery);
    handleMediaQuery(mediaQuery);

    function tabAnim() {
        function getRelativeScrollFraction(element, elementPosition) {
            const height = element.offsetHeight;
            const relativeScrollOffset = window.scrollY - elementPosition;
            let relativeScrollFraction = relativeScrollOffset / height;
            return Math.min(Math.max(relativeScrollFraction, 0), 1);
        }

        function animateElements() {
            const container = document.querySelector('.features-sec-slider__wrapper');
            if (!container) {
                return;
            }

            const blockStart = container.offsetTop;
            let elementPosition = blockStart + 100;

            const elements = Array.from(container.children).slice(0, -1);

            elements.forEach((element) => {
                const relativeScrollFraction = getRelativeScrollFraction(element, elementPosition);
                const maxRotateXFactor = 15;
                let maxRotateX = relativeScrollFraction * maxRotateXFactor;
                maxRotateX = Math.min(maxRotateX, maxRotateXFactor);

                if (maxRotateX >= 10) {
                    maxRotateX = 10
                }

                element.style.opacity = 1 - relativeScrollFraction;
                element.style.transform = `scale(${1 - relativeScrollFraction * 0.1}) translateY(-${relativeScrollFraction * 15}%) rotateX(-${maxRotateX}deg)`;

                elementPosition += element.offsetHeight;
            });
        }

        window.addEventListener('scroll', animateElements);
    }

    function tabAnimMob() {
        function getRelativeScrollFraction(element, elementPosition) {
            const height = element.offsetHeight;
            const relativeScrollOffset = window.scrollY - elementPosition;
            let relativeScrollFraction = relativeScrollOffset / height;
            return Math.min(Math.max(relativeScrollFraction, 0), 1);
        }

        function animateElements() {
            const container = document.querySelector('.features-sec-slider__wrapper');
            if (!container) {
                return;
            }

            const blockStart = container.offsetTop;
            let elementPosition = blockStart + 100;

            const elements = Array.from(container.children).slice(0, -1);

            elements.forEach((element) => {
                const relativeScrollFraction = getRelativeScrollFraction(element, elementPosition);
                const maxRotateXFactor = 15;
                let maxRotateX = relativeScrollFraction * maxRotateXFactor;
                maxRotateX = Math.min(maxRotateX, maxRotateXFactor);

                if (maxRotateX >= 10) {
                    maxRotateX = 10
                }

                element.style.opacity = 1 - relativeScrollFraction;
                element.style.transform = `scale(${1 - relativeScrollFraction * 0.1}) translateY(-${relativeScrollFraction * 15}%)`;

                elementPosition += element.offsetHeight;
            });
        }

        window.addEventListener('scroll', animateElements);
    }


}










